export enum CollapsibleBlock {
  COLLAPSED_BUILDTYPE = 'COLLAPSED_BUILDTYPE',
  COLLAPSED_PIPELINE = 'COLLAPSED_PIPELINE',
  COLLAPSED_BRANCHES_SECTION = 'COLLAPSED_BRANCHES_SECTION',
  COLLAPSED_PROJECT_BLOCK = 'COLLAPSED_PROJECT_BLOCK',
  COLLAPSED_AGENT_POOLS = 'COLLAPSED_AGENT_POOLS',
  COLLAPSED_SUBPROJECT = 'COLLAPSED_SUBPROJECT',
}
